export default __webpack_public_path__ + "static/media/MP0050.f9ae5e38.jpg";